import { render, staticRenderFns } from "./UserCash.vue?vue&type=template&id=4c127440&"
import script from "./UserCash.vue?vue&type=script&lang=js&"
export * from "./UserCash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports